export const API_URL = "https://api.mymerita.com";
export const HOST_URL = "https://mymerita.com";


// export const API_URL = "https://api.mymerita.com";
// export const HOST_URL = "https://mymerita.com";
